import axios from 'axios';
import has from 'lodash/has';

import {
  viewport,
  getCookie,
  setCookie,
  validateUrl,
  isMVA,
  iOSAPP,
  androidAPP,
  getParameterByName,
  getTimeDifferenceFromToday,
  getFlowTypeWithIntend,
  isPreorder,
  crossSiteCheckUrl,
  getSession,
  getUrlName,
  setSession,
  isACPEligibile,
  isVFEligibile,
  isVfDiscountsFlow,
  removeSessionItem,
  getAPPID,
} from '../components/common/Helpers';

import { isCookieExists } from '../components/common/Helpers/cookies';

import { hideFooter, hideGnav } from '../components/common/Helpers/gnav';
import { goToNativePage } from '../components/common/Helpers/app';
import logger from '../components/common/ErrorBoundary/logger_new';
import { ErrorMessage } from '../utils/errorMessage';
import { store } from '../configureStore';

export const getChannelId = () => {
  let channelId = 'VZW-DOTCOM';
  const isRPSFlow = getSession('isRPSFlow');
  if (viewport() === 'mobile' || viewport() === 'mfapp') {
    if (isRPSFlow === 'true') {
      channelId = 'VZW-RPS';
    } else if (iOSAPP()) {
      channelId = 'VZW-MFA-IOS';
    } else if (androidAPP()) {
      channelId = 'VZW-MFA-ANDROID';
      setCookie('channelId', channelId);
    } else {
      channelId = 'VZW-DOTCOM-MOB';
    }
  }
  if (getCookie('channelId') === '') {
    setCookie('channelId', channelId);
  }
  setSession('channelId', channelId);

  return channelId;
};

const xsrfCookieName = isCookieExists('SOE-XSRF-TOKEN-SALES') || isCookieExists('XSRF-TOKEN') || 'XSRF-TOKEN';

const createAxios = axios.create({
  xsrfCookieName,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    channelId: getChannelId(),
    flowName: `${getFlowTypeWithIntend()}`,
  },
});

export const refactorHtppServiceValue = () => createAxios;

export const HttpService = refactorHtppServiceValue();

HttpService.interceptors.request.use((req) => {
  const request = req;
  // add header e2erequestid Removing e2erequestid from UI handling from IG
  // request.headers.e2erequestid = generateRequestId(); // Don't uncomment it.
  // if (window.location.href.indexOf('resumecart') > -1) {
  //   request.headers.FlowName = `${getFlowTypeWithIntend()}`;
  // }

  if (isPreorder()) {
    request.headers.flowName = `${getFlowTypeWithIntend()}`;
  }

  const extraFlowName = [];

  if (isACPEligibile()) {
    extraFlowName.push('ACPEligible');
  }
  if (isVFEligibile()) {
    extraFlowName.push('ACPEligible|VFEligible');
  }
  if (isVfDiscountsFlow()) {
    extraFlowName.push('ACPEligible|VFEligible|FEA_5G');
  }
  if (getSession('ShowLocalBanner', 'Y')) {
    extraFlowName.push('LocalOffer');
  }

  const { search } = window.location;
  const params = new URLSearchParams(search);
  const paramStringValue = params.get('fromemail');
  if (paramStringValue === 'y') {
    if (window.vzFlags?.isFlowNameEnabled) {
      const curHeader = request.headers?.flowName || ""
      let val = ""
      if (curHeader !== "") {
        const newFlowName = `|${getSession('CustTab').trim()}`
        if (newFlowName === curHeader || newFlowName === "|") {
          if (getAPPID() === 'AAL') {
            val = 'AAL_5G|CBD';
          } else {
            val = 'NSE_5G|CBD';
          }
          request.headers.flowName = val
        }
      }
    }
  }

  if (extraFlowName.length) {
    const extraFlowNames = extraFlowName.join('|');
    request.headers.flowName = `${request.headers.flowName}|${extraFlowNames}`;
  }

  // add header X-XSRF-TOKEN for payment APIs
  // Only set if not already provided in custom headers
  if (!request?.headers?.isVPMOrderWriteAPI) {
    const xsrfToken = getCookie('SOE-XSRF-TOKEN-SALES') || getCookie('XSRF-TOKEN');
    if (xsrfToken) {
      request.headers['X-XSRF-TOKEN'] = xsrfToken;
    }
  }

  if (window.document && window.document.referrer) {
    request.headers['from-referrer'] = window.document.referrer;
    request.headers.fromReferrer = window.document.referrer;
  }
  if (getSession('paypalAuthFailed')) {
    request.headers.flowName = `${request.headers.flowName}|Paypal_RS`;
  }
  return request;
});

HttpService.interceptors.response.use(
  (response) => {
    const requestUrl = (response && response.config && response.config.url) || '';
    window.CookieKeys = document?.cookie?.split(';')?.reduce((a, c) => a.set(c?.split('=')?.[0]?.trim(), c?.split('=')?.[1]?.trim()), new Map());
    if (response.data.goToUrl !== undefined || response.data.null !== undefined) {
      window.vzFlags = window.vzFlags || {};
      window.vzFlags.stopServices = true;
      removeSessionItem('amAgentLastCachedTime');
      if (response.data.goToUrl)
        window.location.href = crossSiteCheckUrl(validateUrl(`${decodeURIComponent(response.data.goToUrl)}&goto=${window.location.href}`));
      if (response.data.null)
        window.location.href = crossSiteCheckUrl(validateUrl(`${decodeURIComponent(response.data.null)}&goto=${window.location.href}`));
    } else {
      // Spoke Journey - Hide Gnav (except logo) and footer
      if (response && response.data && ((response.data.data && response.data.data.spokeJourney) || response.data.spokeJourney)) {
        hideGnav({ showLogo: true });
        hideFooter({ persist: true });
      }

      const enableReadFromCookie = getCookie('ENABLE_READ_FROM_COOKIE');
      if (enableReadFromCookie === 'YES') {
        if (response && response.headers && response.headers.vzwaccountnumber) {
          setCookie('customerId', response.headers.vzwaccountnumber);
        }
        if (response && response.headers && response.headers.mobile) {
          setCookie('mtn', response.headers.mobile);
        }
      }
      try {
        if (requestUrl.indexOf('getDetails') > 0 && window.location.href.includes('pdp')) {
          const pdp = response?.data;
          if (pdp) {
            const redirectToBAUflag = redirectToBAU(pdp);
            if (redirectToBAUflag) {
              if (isMVA()) {
                if (window.vzFlags && window.vzFlags.iconicMVARedirectURL && window.vzFlags.iconicMVARedirectURL.includes('gridwall')) {
                  const extraParameters = {
                    mtnToUpgradeReset: 'Y',
                    hideFilter: 'false',
                  };
                  goToNativePage(window.vzFlags.iconicMVARedirectURL, extraParameters);
                } else if (window.vzFlags && window.vzFlags.iconicMVARedirectURL) {
                  goToNativePage(window.vzFlags.iconicMVARedirectURL);
                } else {
                  goToNativePage('shopHomePage');
                }
              } else if (window.vzFlags && window.vzFlags.iconicBauRedirectURL) {
                window.location.href = window.vzFlags.iconicBauRedirectURL;
              } else {
                window.location.href = '/smartphones/';
              }
              return null;
            }
          }
        }
      } catch (error) {
        console.log('Error in HttpService.js', error);
      }
      // Below Try catch is writtern to handle generic Tradein service error scenario
      /**
     * Ticket - > https://onejira.verizon.com/browse/NSADT-47181
     * Error Response ->
     * { "errors": [
        { "namespace": "onevz-soe-tradein-service", "name": "Precondition Failed", "id": "R1001", "debug_id": "", "message": "Case Id is required.", "information_link": "/sales/digital/tradeinstatus/landing.html" }
      ]}
     */
      try {
        if (
          requestUrl.indexOf('tradeinservice') > 0 ||
          requestUrl.indexOf('deviceconfigservice') > 0 ||
          requestUrl.indexOf('plansservice') > 0 ||
          requestUrl.indexOf('orderprocessservice') > 0
        ) {
          const isRedirect =
            response && response.data && response.data.errors && response.data.errors.length > 0 && response.data.errors[0].id === 'R1001';
          if (
            isRedirect &&
            response &&
            response.data &&
            response.data.errors &&
            response.data.errors.length > 0 &&
            response.data.errors[0].information_link
          ) {
            window.location.href = response.data.errors[0].information_link;
          }
        }
      } catch (error) {
        console.log('Error in HttpService.js', error);
      }
      try {
        if (requestUrl.indexOf('get-checkout-details') > 0 || requestUrl.indexOf('validate-cart') > 0) {
          const cartData =
            response?.data?.data?.validateCartAndUpdate || response?.data?.data?.cart;
          const lineDetails = (cartData && cartData.lineDetails) || null;
          if (lineDetails) {
            const purchasePath = selectPurchasePath(lineDetails);
            setSession('purchasePath', purchasePath);
          } else {
            setSession('purchasePath', '');
          }
        }
      } catch (error) {
        console.log('Error in HttpService.js', error);
      }
      // if (!isMobile() && !isMVA()) {
      //   setTimeout(() => showFooter(), 2000);
      // }
      if (response?.data?.errors && response.data.errors.length > 0 && window.vzFlags && !window.vzFlags.showServicesError) {
        const { errors } = response.data;
        const nameMatch = ['API_ERROR', 'HTTP_ERROR', 'SYSTEM_ERROR'];
        const DEFAULT_ERR_MSG = 'We are unable to process the request at this time. Please try after sometime';
        if (nameMatch.includes(errors[0].name)) {
          response.data.errors[0].networkMessage = response.data.errors[0].message || 'Error message not provided by SOE services';
          response.data.errors[0].message = DEFAULT_ERR_MSG;
        }
      }
      // We are going to keep this until SOE captures all CXP errors
      if (response && response.data && response.data.errors && response.data.errors.length > 0) {
        const { errors } = response.data;
        if (errors[0]?.id === '1004') {
          store.dispatch({ type: 'SHOW_DEVICELOCK_MODAL', openModal: true });
        }
        if (errors[0].message && errors[0].message.includes('UNABLE TO CONNECT')) {
          response.data.errors[0].networkMessage = response.data.errors[0].message;
          response.data.errors[0].message = 'We are unable to process the request at this time. Please try after sometime';
        }
      }

      // Proactive chat setting errorCode , pro to vzflag object and
      // setting it to vzdl once vzdl object is available
      if (response?.data?.errors && response.data.errors.length > 0) {
        if (
          response.data.errors[0] &&
          response.data.errors[0].proactiveChatCustomMSG &&
          response.data.errors[0].proactiveChatIndicator &&
          window.vzFlags
        ) {
          if (!window.vzFlags.proactiveChatIndicators) {
            window.vzFlags.proactiveChatIndicators = {};
          }
          window.vzFlags.proactiveChatIndicators.errorCode = response.data.errors[0].id;
          window.vzFlags.proactiveChatIndicators.proactiveChatCustomMSG = response.data.errors[0].proactiveChatCustomMSG;
          window.vzFlags.proactiveChatIndicators.proactiveChatIndicator = response.data.errors[0].proactiveChatIndicator;
        }
      }
      if (response?.data?.errors?.length && response.data.errors[0].id !== '1004') {
        const errorMessageData = ErrorMessage(response.data.errors, getUrlName(window.location.href));
        const loggerInfo = createLoggerObject(response, errorMessageData, 'FeErrorB');
        response.data.errors[0].notifyMessage = errorMessageData.message;
        response.data.loggerData = loggerInfo;
        if (errorMessageData.redirect) {
          routeToPage(loggerInfo, errorMessageData.message);
          return null;
        }
      }
      return response;
    }
    return response;
  },
  (error) => {
    // const e2eId = error?.headers?.e2erequestid || '';
    if (typeof error !== 'string') {
      const { response } = error;
      let errorMessageData = {
        noteMessage: 'errorIdNotPresent',
        message: 'Looks like something went wrong. Please try again later.',
        redirect: false,
      };

      if (response?.data?.errors && response.data.errors.length > 0) {
        if (response.data.errors[0]?.id === '1004') {
          store.dispatch({ type: 'SHOW_DEVICELOCK_MODAL', openModal: true });
        } else {
          errorMessageData = ErrorMessage(response.data.errors, getUrlName(window.location.href));
          response.data.errors[0].notifyMessage = errorMessageData.message;
        }
      }
      const loggerInfo = createLoggerObject(error, errorMessageData, 'FeErrorS');
      if (response?.data?.errors) {
        response.data.loggerData = loggerInfo;
      }
      if (errorMessageData.redirect) {
        routeToPage(loggerInfo, errorMessageData.message);
        return null;
      }
      return response;
    }
    return error;
  },
);

const getServiceError = (errorResponse) => {
  if (Array.isArray(errorResponse?.response?.data)) {
    return errorResponse?.response?.data?.errors[0];
  }
  return null;
};

const createLoggerObject = (errRsp, errorMessageData, subEvtType) => {
  const apiUrl = errRsp?.config?.url || '';
  const e2eId = errRsp?.headers?.e2erequestid || '';
  return {
    json: true,
    eventType: 'FeError',
    message: `${errorMessageData?.message || ''}`,
    note: `from Page: ${getUrlName(window.location.href)} - API: ${apiUrl} - ${errorMessageData?.noteMessage}`,
    messageType: 'ERROR',
    errorCategory: 'API-ERROR',
    serviceUrl: apiUrl,
    e2erequestid: e2eId,
    networkError: {
      error: subEvtType === 'FeErrorB' ? errRsp?.data?.errors[0] : getServiceError(errRsp),
      response: subEvtType === 'FeErrorB' ? errRsp : errRsp?.response || null,
      message: errRsp?.message || '',
      stack: errRsp?.stack || '',
      subEventType: subEvtType,
    },
  };
};

const routeToPage = (loggerInfo, message) => {
  const loggerData = loggerInfo;
  loggerData.note = `${loggerData?.note} routeToPage url: ${message}`;
  logger(loggerData);
  setSession('routeToPage', 'Y');
  window.location.href = crossSiteCheckUrl(message.split('/').pop());
};

export const redirectToBAU = (pdp) => {
  if (isMVA()) {
    return false;
  }
  const productId = getParameterByName('productid');
  if (
    window &&
    window.vzFlags &&
    window.vzFlags.iconicDisableProductIds &&
    window.vzFlags.iconicDisableProductIds.length > 0 &&
    window.vzFlags.iconicDisableProductIds.includes(productId)
  ) {
    if (pdp && pdp.data && pdp.data?.accountInfo?.preOrderMTNEnable === 'true') {
      return false;
    }
    if (
      pdp?.data?.deviceProduct &&
      pdp.data.deviceProduct.startDate &&
      pdp.data.deviceProduct.startDate.dateTime &&
      getTimeDifferenceFromToday(pdp.data.deviceProduct.startDate.dateTime) > 0
    ) {
      return true;
    }
  }
  return false;
};

export const selectPurchasePath = (lineDetails) => {
  let purchasePath = '';
  const lineActivityTypes =
    has(lineDetails, 'lineInfo') &&
    lineDetails.lineInfo.length > 0 &&
    lineDetails.lineInfo.filter((ln) => ln.lineActivityType !== 'CPC' && ln.lineActivityType !== 'FEA').map((line) => line.lineActivityType);
  if (lineActivityTypes && lineActivityTypes.length === 0) {
    return '';
  }
  if (!lineActivityTypes) {
    return ';';
  }
  const lineCount = (arr, val) => arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
  const hasByodLines = !!(lineCount(lineActivityTypes, 'BYOD') > 0);
  const hasACCLines = !!(lineCount(lineActivityTypes, 'ACC') > 0);
  const hasEUPLines = !!(lineCount(lineActivityTypes, 'EUP') > 0);
  const hasAALLines = !!(lineCount(lineActivityTypes, 'AAL') > 0);
  const totalLines = (lineActivityTypes && lineActivityTypes.length) || 0;
  if (totalLines === 1) {
    if (lineActivityTypes[0] === 'BYOD') purchasePath = 'NSO';
    if (lineActivityTypes[0] === 'ACC') purchasePath = 'NAO';

    if (lineActivityTypes[0] !== 'BYOD' && lineActivityTypes[0] !== 'ACC') {
      // eslint-disable-next-line prefer-destructuring
      purchasePath = lineActivityTypes[0];
    }
  } else if (totalLines === lineCount(lineActivityTypes, 'AAL')) {
    purchasePath = 'AAL';
  } else if (totalLines === lineCount(lineActivityTypes, 'EUP')) {
    purchasePath = 'EUP';
  } else if (totalLines === lineCount(lineActivityTypes, 'BYOD')) {
    purchasePath = 'NSO';
  } else if (totalLines === lineCount(lineActivityTypes, 'ACC')) {
    purchasePath = 'NAO';
  } else if (hasACCLines && (hasAALLines || hasEUPLines || hasByodLines)) {
    if (hasAALLines) purchasePath = 'AAL';
    if (hasEUPLines) purchasePath = 'EUP';
    if (hasByodLines) purchasePath = 'NSO';
  }
  if (
    (hasAALLines && hasEUPLines && hasByodLines) ||
    (hasAALLines && hasEUPLines && !hasByodLines) ||
    (hasAALLines && !hasEUPLines && hasByodLines) ||
    (!hasAALLines && hasEUPLines && hasByodLines)
  ) {
    purchasePath = 'MOT';
  }
  return purchasePath;
};
